// /wallet-ops → /wallet-ops/config. The bare section URL lands on the
// Config page.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/wallet-ops/")({
  beforeLoad: () => {
    throw redirect({ to: "/wallet-ops/config", replace: true });
  },
});
